export async function requestDeleteFeed(id: number) {
  return http.post('/v1/feeds/delete', {
    id
  })
}
